var map = {
	"./icon-map-marker-poi-active-1100.png": 9025,
	"./icon-map-marker-poi-active-3100.png": 2067,
	"./icon-map-marker-poi-active-3150.png": 4953,
	"./icon-map-marker-poi-active-3300.png": 3246,
	"./icon-map-marker-poi-active-3350.png": 4657,
	"./icon-map-marker-poi-active-8200.png": 2966,
	"./icon-map-marker-poi-active-8300.png": 4957,
	"./icon-map-marker-poi-active-default.png": 7070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 812;